import { useCallback, useEffect, useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { OnVisibleNotifier } from 'src/components/OnVisibleNotifier';

import { useStyles } from './useStyles';

const LOAD_MORE_TIMEOUT = 300;

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func,
};

const defaultProps = {
  className: null,
  classes: null,
  loading: false,
  onLoadMore: null,
};

export const InfiniteScrollLoader = ({ className, classes, loading, onLoadMore }) => {
  const styles = useStyles({ classes });

  const [visible, setVisible] = useState(false);
  const handleVisible = useCallback((value) => {
    setVisible(value);
  }, []);

  // When we are 'visible' and not 'loading' currently, then wait for timeout and 'load more'
  useEffect(() => {
    if (loading || !visible || !onLoadMore) {
      return undefined;
    }

    const timer = setTimeout(() => onLoadMore(), LOAD_MORE_TIMEOUT);
    return () => clearTimeout(timer);
  }, [loading, visible, onLoadMore]);

  return (
    <div className={cx(styles.root, className)}>
      {!loading && onLoadMore && (
        <OnVisibleNotifier
          className={styles.notifier}
          onNotify={handleVisible}
        />
      )}

      {loading && (
        <div className={styles.loader}>
          <CircularProgress size={32} />
        </div>
      )}
    </div>
  );
};

InfiniteScrollLoader.propTypes = propTypes;
InfiniteScrollLoader.defaultProps = defaultProps;
